// Shared by the Routing skill and browser-facing agent context schemas.
export const SITE_ID = /^[a-zA-Z0-9-]{1,100}$/;
